module.exports = __webpack_public_path__ + "img/HoveredSwap.3e4a2383.svg";